module.exports = __webpack_public_path__ + "static/img/service-bg.7b42b0d5.png";